export const validateFields = (
  data,
  fieldValidations,
  customMessages = {},
  translation
) => {
  let errors = [];

  fieldValidations.forEach(
    ({
      field,
      label,
      regexChars,
      regexSapces,
      regexPrefix,
      minLength,
      maxLength,
      emptyErrorMsg,
      lengthErrorMsg,
      formatErrorMsg,
      spaceErrorMsg,
      prefixErrorMsg,
    }) => {
      const value = data[field];
      const messages = customMessages[field] || {};

      // Check for empty value
      if (!value) {
        errors[field] = messages.emptyErrorMsg
          ? translation.getTranslation(messages.emptyErrorMsg) +
              " " +
              translation.getTranslation(label) || emptyErrorMsg
          : undefined;
      }

      // Check for wrong prefix
      else if (regexPrefix && !regexPrefix.test(value)) {
        errors[field] =
          translation.getTranslation(messages.prefixErrorMsg) || prefixErrorMsg;
      }

      // Check for unnecessary space
      else if (regexSapces && !regexSapces.test(value)) {
        errors[field] =
          translation.getTranslation(messages.spaceErrorMsg) || spaceErrorMsg;
      }

      // Check minimum length
      else if (minLength && value.length < minLength) {
        errors[field] =
          translation.getTranslation(messages.lengthErrorMsg) || lengthErrorMsg;
      }

      // Check maximum length
      else if (maxLength && value.length > maxLength) {
        errors[field] =
          translation.getTranslation(messages.lengthErrorMsg) || lengthErrorMsg;
      }

      // Check format
      else if (regexChars && !regexChars.test(value)) {
        errors[field] =
          translation.getTranslation(messages.formatErrorMsg) || formatErrorMsg;
      }
    }
  );

  return errors;
};
